import Cookies from 'js-cookie'

const flag = {
  state: {
    haveCheckedAppAuth: Cookies.get('haveCheckedAppAuth') || false, // 用于检查在当前web应用生命周期内是否已经尝试过app登录
  },
  mutations: {
    SET_HAVE_CHECKED_APP_AUTH: (state, value) => {
      state.haveCheckedAppAuth = value
    },
  },
  actions: {
    async setHaveCheckedAppAuth({ commit }, value) {
      commit('SET_HAVE_CHECKED_APP_AUTH', value)
    },
  }
}

export default flag
